export default "__VITE_ASSET__fbfe85f8__"